// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'face-blank';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 17.438A8.438 8.438 0 1 0 9 .561a8.438 8.438 0 0 0 0 16.875z' />
    <path d='M6.188 7.031a.281.281 0 0 1 0-.562m0 .562a.281.281 0 0 0 0-.562m5.625.562a.281.281 0 0 1 0-.562m0 .562a.281.281 0 0 0 0-.562m-6.188 5.344h6.75' />
  </g>
);

export const viewBox = '0 0 18 18';
